export const partnersDe = {
  discardTitle: 'Ungespeicherte Änderungen verwerfen?',
  discardDescription:
    'Ihre Änderungen wurden noch nicht gespeichert. Sie können weiterbearbeiten oder sie ausdrücklich verwerfen.',
  keepEditing: 'Weiterbearbeiten',
  discard: 'Verwerfen',

  all: {
    title: 'Alle Kontakte',
    subtitle: 'Gesamtübersicht aller Geschäftspartner mit ihren Rollen.',
  },
  customers: {
    title: 'Kunden',
    subtitle: 'Debitorenstamm, Konditionen und Umsätze aller aktiven Kunden.',
  },
  prospects: {
    title: 'Interessenten / Leads',
    subtitle: 'Vertriebspipeline vom Erstkontakt bis zum Abschluss.',
  },
  suppliers: {
    title: 'Lieferanten',
    subtitle: 'Kreditorenstamm, Bewertung und Einkaufskonditionen.',
  },
  searchPlaceholder: 'Suche nach Name, Nummer, Ort, USt-IdNr., Konto …',
  searchLabel: 'Geschäftspartner durchsuchen',
  columnsMenu: 'Spalten',
  createTitle: 'Neuer Geschäftspartner',
  editTitle: 'Geschäftspartner bearbeiten',
  formDescription:
    'Die Rollen steuern, welche Fachfelder erscheinen. Die Partnernummer wird bei Bedarf automatisch vergeben.',
  created: 'Geschäftspartner angelegt.',
  updated: 'Geschäftspartner gespeichert.',
  saveError: 'Der Geschäftspartner konnte nicht gespeichert werden.',
  validationTitle: 'Angaben prüfen',
  validationSummary: 'Bitte prüfen Sie die markierten Angaben. Ihre Eingaben bleiben erhalten.',
  quick: {
    title: 'Schnell anlegen',
    description: 'Für die Anlage genügen Rolle und Name. Alles Weitere können Sie später ergänzen.',
    completeTitle: 'Vollständige Anlage',
    completeDescription: 'Alle verfügbaren Stamm- und Konditionsdaten bearbeiten.',
    showAll: 'Alle Felder anzeigen',
    showQuick: 'Zur Schnellanlage',
    defaultsUnavailable:
      'Die Mandantenstandards konnten vorübergehend nicht geladen werden. Es werden sichere Standardwerte angezeigt.',
    step1: '1. Kunde beziehungsweise Unternehmen',
    step2: '2. Adresse (optional)',
    step3: '3. Kontakt (optional)',
    step4: '4. Abrechnung und Steuer (optional)',
    completionHint:
      'Nach dem Speichern können Sie die Akte vervollständigen. Vor einer Festschreibung zeigt der Beleg fehlende Fachangaben als Checkliste.',
  },
  roles: {
    customer: 'Kunde',
    prospect: 'Interessent',
    supplier: 'Lieferant',
  },
  actions: {
    create: 'Neuer Partner',
    createCustomer: 'Neuer Kunde',
    createProspect: 'Neuer Interessent',
    createSupplier: 'Neuer Lieferant',
    export: 'Export',
    call: 'Anrufen',
    email: 'E-Mail',
    logCall: 'Telefonat erfassen',
    createQuote: 'Beleg erstellen',
    convert: 'Zu Kunde umwandeln',
    backToList: 'Zurück zur Übersicht',
  },
  tabs: {
    master: 'Stammdaten & Adressen',
    sales: 'Umsatz & Belege',
    purchasing: 'Einkauf & Artikel',
    orders: 'Bestellungen',
    insurance: 'Kreditlimit & Versicherung (WKV)',
    customFields: 'Zusatzfelder',
    history: 'Historie',
    questionnaires: 'Fragebögen',
    telephony: 'Telefonie & Historie',
    whatsapp: 'WhatsApp',
  },
  sections: {
    roles: 'Rollen',
    rolesHint:
      'Ein Partner kann gleichzeitig Kunde, Interessent und Lieferant sein. Mindestens eine Rolle ist erforderlich.',
    masterData: 'Stammdaten',
    address: 'Adresse',
    tax: 'Steuer & Identifikation',
    customerConditions: 'Kundenkonditionen',
    prospect: 'Interessent & Pipeline',
    supplier: 'Lieferantendaten',
    customFields: 'Zusatzfelder',
    customFieldsHint:
      'Felder mit Gruppenpräfix (customer:, prospect:, supplier:) erscheinen nur bei der passenden Rolle.',
  },
  detail: {
    since: 'Angelegt am {{date}}',
  },
  values: {
    days_one: '{{count}} Tag',
    days_other: '{{count}} Tage',
  },
  columns: {
    partnerNumber: 'Nummer',
    displayName: 'Name',
    roles: 'Rollen',
    status: 'Status',
    industry: 'Branche',
    industryCode: 'Branchencode',
    email: 'E-Mail',
    phone: 'Telefon',
    city: 'Ort',
    countryCode: 'Land',
    tags: 'Schlagworte',
    debtorAccountNumber: 'Debitor',
    paymentTermsDays: 'Zahlungsziel',
    creditLimit: 'Kreditlimit',
    leadStatus: 'Stufe',
    leadSource: 'Quelle',
    leadScore: 'Score',
    dealSizeEstimated: 'Potenzial',
    winProbability: 'Wahrscheinlichkeit',
    expectedClosingDate: 'Abschluss geplant',
    creditorAccountNumber: 'Kreditor',
    supplierRating: 'Bewertung',
    minimumOrderValue: 'Mindestbestellwert',
    deliveryTimeDays: 'Lieferzeit',
    riskStatus: 'Risiko',
  },
  fields: {
    type: 'Partnerart',
    status: 'Status',
    partnerNumber: 'Partnernummer',
    partnerNumberHint: 'Leer lassen für automatische Vergabe (KD-, INT-, LF-).',
    industry: 'Branche',
    industryCode: 'Branchencode',
    industryCodeHint:
      'Optional: WZ 2025 für Deutschland, NAF/APE für Frankreich. Nach Code oder amtlicher Bezeichnung suchen; die Auswahl füllt die Branche automatisch.',
    industryCodeSearchHint:
      '{{count}} Codes verfügbar. Geben Sie einen Code oder Suchbegriff ein, um die Auswahl einzugrenzen.',
    industryCodeInvalid: 'Bitte einen Text mit höchstens {{max}} Zeichen eingeben.',
    companyName: 'Firmenname',
    tradingName: 'Handelsname',
    legalForm: 'Rechtsform',
    department: 'Abteilung',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    mobile: 'Mobil',
    website: 'Website',
    street: 'Straße',
    houseNumber: 'Hausnummer',
    addressLine2: 'Adresszusatz',
    postalCode: 'PLZ',
    city: 'Ort',
    region: 'Region',
    countryCode: 'Land',
    vatId: 'USt-IdNr.',
    vatIdStatus: 'Prüfstatus USt-IdNr.',
    taxNumber: 'Steuernummer',
    siren: 'SIREN',
    siret: 'SIRET',
    taxCategory: 'Umsatzsteuer-Strategie',
    gln: 'GLN',
    eoriNumber: 'EORI-Nummer',
    preferredLanguage: 'Bevorzugte Belegsprache',
    preferredLanguageHint:
      'Wird für neue Belege, Portal-Inhalte und kundenbezogene E-Mails übernommen.',
    currency: 'Währung',
    ownerName: 'Betreuer',
    tags: 'Schlagworte',
    tagsHint: 'Mehrere Werte durch Komma trennen.',
    debtorAccountNumber: 'DATEV-Debitorenkonto',
    debtorAccountHint: 'Zulässiger Bereich: 10000–69999.',
    creditLimit: 'Kreditlimit',
    creditRating: 'Bonitätsindex',
    creditRatingHint: 'Creditreform-Skala 100–600; kleiner ist besser.',
    priceGroup: 'Preisgruppe',
    defaultDiscountPct: 'Rabatt',
    paymentTerms: 'Zahlungsbedingungen',
    paymentTermsDays: 'Zahlungsziel (Tage)',
    discountPercent: 'Skonto',
    discountDays: 'Skontofrist (Tage)',
    deliveryTerms: 'Lieferbedingung',
    minRemainingShelfLifeDays: 'Mindestrestlaufzeit (Tage)',
    deliveryBlock: 'Liefersperre',
    dunningBlock: 'Mahnsperre',
    leadStatus: 'Pipeline-Stufe',
    leadSource: 'Herkunft',
    leadScore: 'Lead-Score (0–100)',
    dealSizeEstimated: 'Erwartetes Umsatzpotenzial',
    winProbability: 'Abschlusswahrscheinlichkeit (%)',
    expectedClosingDate: 'Geplanter Abschluss',
    lostReason: 'Verlustgrund',
    convertedAt: 'Umgewandelt am',
    creditorAccountNumber: 'DATEV-Kreditorenkonto',
    creditorAccountHint: 'Zulässiger Bereich: 70000–99999.',
    supplierRating: 'Lieferantenbewertung',
    minimumOrderValue: 'Mindestbestellwert',
    deliveryTimeDays: 'Regellieferzeit (Tage)',
    incoterms: 'Incoterms',
    supplierIban: 'IBAN',
    supplierBic: 'BIC',
    supplierBankName: 'Bank',
  },
  types: {
    COMPANY: 'Firma',
    PERSON: 'Privatperson',
  },
  statuses: {
    ACTIVE: 'Aktiv',
    PROSPECT: 'Interessent',
    BLOCKED: 'Gesperrt',
    INACTIVE: 'Inaktiv',
  },
  vatIdStatuses: {
    UNCHECKED: 'Ungeprüft',
    VALID: 'Gültig',
    INVALID: 'Ungültig',
    NOT_CHECKABLE: 'Nicht prüfbar',
    SERVICE_UNAVAILABLE: 'Dienst nicht erreichbar',
  },
  taxCategories: {
    DOMESTIC: 'Regelbesteuerung (Inland)',
    EU_B2B: 'Innergemeinschaftlich (EU B2B)',
    EU_B2C: 'EU B2C',
    THIRD_COUNTRY: 'Ausfuhr (Drittland)',
    REVERSE_CHARGE_DOMESTIC: 'Reverse Charge (Inland)',
    TAX_EXEMPT: 'Steuerbefreit',
  },
  industries: {
    RETAIL: 'Einzelhandel',
    WHOLESALE: 'Großhandel',
    MANUFACTURING: 'Produktion',
    GASTRONOMY: 'Gastronomie',
    LOGISTICS: 'Logistik',
    HEALTHCARE: 'Gesundheitswesen',
    PUBLIC_SECTOR: 'Öffentlicher Sektor',
    CONSTRUCTION: 'Bau',
    AGRICULTURE: 'Landwirtschaft',
    SERVICES: 'Dienstleistung',
    OTHER: 'Sonstige',
  },
  leadStatuses: {
    NEW: 'Neu',
    CONTACTED: 'Kontaktiert',
    QUALIFIED: 'Qualifiziert',
    PROPOSAL_SENT: 'Angebot',
    NEGOTIATION: 'Verhandlung',
    WON: 'Gewonnen',
    LOST: 'Verloren',
  },
  leadSources: {
    WEBSITE: 'Website',
    TRADE_FAIR: 'Messe',
    REFERRAL: 'Empfehlung',
    COLD_OUTREACH: 'Kaltakquise',
    INBOUND_CALL: 'Eingehender Anruf',
    OTHER: 'Sonstige',
  },
  supplierRatings: {
    A: 'A – Sehr zuverlässig',
    B: 'B – Akzeptabel',
    C: 'C – Kritisch',
  },
  riskStatuses: {
    NORMAL: 'Unauffällig',
    WATCHLIST: 'Beobachtung',
    DELIVERY_LOCK: 'Liefersperre',
    SALES_LOCK: 'Verkaufssperre',
    COLLECTION: 'Inkasso / gesperrt',
    INSOLVENCY: 'Insolvenz',
  },
  risk: {
    lockAction: 'Kunde sperren',
    unlockAction: 'Kunde entsperren',
    lockTitle: 'Geschäftspartner sperren',
    lockDescription:
      'Die Sperre unterbindet ab sofort jede Belegerstellung für {{name}}. Die Begründung wird revisionssicher protokolliert.',
    lockConfirm: 'Sperre setzen',
    lockSuccess: 'Der Geschäftspartner ist gesperrt.',
    lockError: 'Die Sperre konnte nicht gesetzt werden.',
    unlockTitle: 'Sperre aufheben',
    unlockDescription: 'Die Sperre von {{name}} wird aufgehoben. Bisheriger Grund: {{reason}}',
    unlockConfirm: 'Sperre aufheben',
    unlockSuccess: 'Die Sperre wurde aufgehoben.',
    unlockError: 'Die Sperre konnte nicht aufgehoben werden.',
    reasonRequired: 'Eine Begründung ist erforderlich.',
    fields: {
      riskStatus: 'Risikoeinstufung',
      followUpStatus: 'Einstufung nach der Freigabe',
      blockReason: 'Begründung der Sperre',
      blockReasonHint:
        'Beispiel: „Aktenzeichen Insolvenzgericht: IN 412/26“ oder „Übergabe an Inkasso Creditreform am 15.08.2026“.',
      unblockReason: 'Begründung der Freigabe',
      unblockReasonHint: 'Beispiel: „Forderung vollständig ausgeglichen am 01.09.2026“.',
    },
    banner: {
      blockedTitle: '🚨 ACHTUNG: KUNDE IST GESPERRT (Status: {{status}})',
      warningTitle: 'Risikoeinstufung: {{status}}',
      reason: 'Grund: {{reason}}',
      since: 'Gesperrt am {{date}} durch {{user}}',
      consequence:
        'Es dürfen keine Lieferungen oder Rechnungen auf Ziel erstellt werden — Freigabe nur gegen Vorkasse oder Barzahlung.',
    },
  },
  insurance: {
    policySection: 'Versicherungspolice',
    claimSection: 'Schadensfall',
    saved: 'Die Warenkreditversicherung wurde gespeichert.',
    saveError: 'Die Warenkreditversicherung konnte nicht gespeichert werden.',
    limitExceededHint:
      'Das versicherte Höchstlimit ist ausgeschöpft. Weitere Lieferungen sind nicht gedeckt.',
    claimIdleHint:
      'Der Schadensbereich wird relevant, sobald der Kunde in Inkasso oder Insolvenz übergeht.',
    openAmount: 'Offene Posten: {{amount}}',
    expectedPayout: 'Erwartete Erstattung der Versicherung',
    expectedPayoutHint: 'Schadenssumme abzüglich Selbstbehalt von {{percent}}.',
    actions: {
      prepareClaim: 'Schadensmeldung erfassen',
    },
    statuses: {
      NOT_INSURED: 'Keine Versicherung',
      INSURED: 'WKV-versichert',
      LIMIT_EXCEEDED: 'Limit überschritten',
      CLAIM_REPORTED: 'Schadensfall gemeldet',
      INDEMNIFIED: 'Entschädigt',
    },
    fields: {
      status: 'Versicherungsstatus',
      company: 'Versicherungsgesellschaft',
      companyHint: 'Beispiel: Allianz Trade / Euler Hermes, Atradius, Coface.',
      policyNumber: 'Versicherungsschein-/Limit-Nr.',
      limit: 'Versichertes Höchstlimit (€)',
      deductiblePercent: 'Selbstbehalt (%)',
      deductibleHint: 'Anteil, den der Mandant im Schadensfall selbst trägt.',
      claimDate: 'Datum der Schadensmeldung',
      claimAmount: 'Gemeldete Schadenssumme (€)',
      payoutAmount: 'Erstatteter Betrag (€)',
    },
  },
  incoterms: {
    EXW: 'Ab Werk',
    FCA: 'Frei Frachtführer',
    FAS: 'Frei Längsseite Schiff',
    FOB: 'Frei an Bord',
    CFR: 'Kosten und Fracht',
    CIF: 'Kosten, Versicherung, Fracht',
    CPT: 'Fracht bezahlt bis',
    CIP: 'Fracht und Versicherung bezahlt bis',
    DAP: 'Geliefert benannter Ort',
    DPU: 'Geliefert entladen',
    DDP: 'Geliefert verzollt',
  },
  documentTypes: {
    QUOTE: 'Angebot',
    ORDER: 'Auftrag',
    DELIVERY_NOTE: 'Lieferschein',
    INVOICE: 'Rechnung',
    CREDIT_NOTE: 'Gutschrift',
    CANCELLATION: 'Storno',
    PURCHASE_ORDER: 'Bestellung',
  },
  documentStatuses: {
    DRAFT: 'Entwurf',
    SENT: 'Versendet',
    ACCEPTED: 'Angenommen',
    REJECTED: 'Abgelehnt',
    CONFIRMED: 'Bestätigt',
    IN_PROGRESS: 'In Bearbeitung',
    PARTIALLY_PROCESSED: 'Teilweise bearbeitet',
    SHIPPED: 'Versendet',
    COMPLETED: 'Abgeschlossen',
    POSTED: 'Festgeschrieben',
    CANCELLED: 'Storniert',
  },
  filters: {
    status: 'Status',
    industry: 'Branche',
    industryCode: 'Branchencode filtern (exakt)',
    tags: 'Schlagworte',
    vatIdStatus: 'USt-IdNr.',
    riskStatus: 'Risiko',
    leadStatus: 'Pipeline-Stufe',
    leadSource: 'Herkunft',
    supplierRating: 'Bewertung',
    reset: 'Filter zurücksetzen',
  },
  states: {
    empty: 'Noch keine Geschäftspartner erfasst.',
    emptyFiltered: 'Keine Geschäftspartner für die aktuelle Auswahl.',
    error: 'Die Liste konnte nicht geladen werden.',
    detailError: 'Der Geschäftspartner konnte nicht geladen werden.',
  },
  export: {
    csv: 'CSV herunterladen',
    xlsx: 'Excel herunterladen',
    success: 'Export erstellt.',
    error: 'Der Export ist fehlgeschlagen.',
  },
  bulkDelete: {
    selected: 'Ausgewählt: {{count}}',
    action: 'Auswahl löschen',
    help: 'Hilfe zur Massenlöschung von Interessenten',
    deleted: 'Gelöscht: {{count}}.',
    failed: 'Nicht gelöscht: {{count}}. Diese Einträge bleiben ausgewählt.',
    hasDocuments: 'Dieser Geschäftspartner besitzt Belege und kann nicht gelöscht werden.',
    error: 'Der Eintrag konnte nicht gelöscht werden.',
    title: 'Ausgewählte Interessenten löschen',
    description:
      'Die ausgewählten Interessenten werden inaktiv gesetzt und ausgeblendet. Partner mit Belegen bleiben erhalten. Die Löschung betrifft den gesamten Geschäftspartner einschließlich weiterer Rollen.',
    select: '{{name}} auswählen',
    selectPage: 'Alle auf dieser Seite auswählen',
  },
  delete: {
    title: 'Geschäftspartner löschen',
    description: 'Der Partner "{{name}}" wird inaktiv gesetzt und ausgeblendet.',
    success: 'Geschäftspartner gelöscht.',
    error: 'Der Geschäftspartner konnte nicht gelöscht werden.',
  },
  pipeline: {
    title: 'Vertriebspipeline',
    viewSwitch: 'Ansicht wechseln',
    listView: 'Liste',
    boardView: 'Board',
    emptyColumn: 'Keine Einträge',
    moved: '{{name}} nach „{{stage}}" verschoben.',
    moveError: 'Die Pipeline-Stufe konnte nicht geändert werden.',
    movePrevious: '{{name}} eine Stufe zurück',
    moveNext: '{{name}} eine Stufe weiter',
    lostTitle: 'Interessent als verloren markieren',
    lostDescription: 'Bitte den Grund für den Verlust angeben.',
    lostPlaceholder: 'z. B. Preis zu hoch, Wettbewerber gewählt, Projekt verschoben',
  },
  convert: {
    title: 'Interessent in Kunde umwandeln',
    description:
      'Der Datensatz "{{name}}" bleibt erhalten; Anrufe, Notizen, Angebote und Chats werden übernommen.',
    debtorHint: 'Leer lassen: Die nächste freie DATEV-Debitorennummer wird vergeben.',
    debtorPlaceholder: 'automatisch',
    keepProspectRole: 'Rolle „Interessent" zusätzlich beibehalten',
    success: 'Umwandlung abgeschlossen. Debitorenkonto {{number}}.',
    error: 'Die Umwandlung ist fehlgeschlagen.',
  },
  sales: {
    title: 'Umsatz & Zahlungsverhalten',
    loadError: 'Die Kennzahlen konnten nicht geladen werden.',
    revenueYtd: 'Umsatz laufendes Jahr',
    revenuePreviousYear: 'Umsatz Vorjahr',
    revenueChange: 'Veränderung zum Vorjahr',
    orderIntake: 'Auftragseingang',
    documentCounts: 'Angebote / Aufträge / Lieferscheine / Rechnungen',
    averageOrderValue: 'Ø Auftragswert',
    paidAmount: 'Bezahlter Betrag',
    credits: 'Gutschriften und Stornos',
    lastDocuments: 'Letzter Auftrag / letzte Rechnung',
    period: 'Zeitraum',
    periods: {
      currentYear: 'Laufendes Jahr',
      previousYear: 'Vorjahr',
      last12Months: 'Letzte 12 Monate',
      all: 'Gesamt',
      custom: 'Freier Zeitraum',
    },
    from: 'Von',
    to: 'Bis',
    searchDocuments: 'Belegnummer oder Referenz suchen …',
    allTypes: 'Alle Belegarten',
    allStatuses: 'Alle Status',
    allPayments: 'Alle Zahlungsstatus',
    noDocumentPermission: 'Für Umsatzkennzahlen und Belege fehlt die Belegberechtigung.',
    columns: {
      number: 'Belegnummer',
      type: 'Art',
      date: 'Datum',
      status: 'Status',
      payment: 'Zahlung',
      net: 'Netto',
      gross: 'Brutto',
      open: 'Offen',
      due: 'Fälligkeit',
      salesRep: 'Vertrieb',
    },
    revenueTotal: 'Umsatz gesamt',
    openInvoices_one: 'Offene Rechnung ({{count}})',
    openInvoices_other: 'Offene Rechnungen ({{count}})',
    overdueInvoices_one: 'Überfällige Rechnung ({{count}})',
    overdueInvoices_other: 'Überfällige Rechnungen ({{count}})',
    openQuotes: 'Offene Angebote',
    openOrders: 'Offene Aufträge',
    averagePaymentTermsDays: 'Ø Zahlungsziel',
    lastOrderDate: 'Letzter Auftrag',
    documents: 'Belege',
    documentsEmpty: 'Noch keine Belege vorhanden.',
    documentsError: 'Die Belege konnten nicht geladen werden.',
  },
  supplierProducts: {
    title: 'Einkaufskonditionen',
    subtitle: 'Artikel, Lieferanten-Artikelnummern, EK-Preise und Lieferzeiten.',
    add: 'Artikel verknüpfen',
    createTitle: 'Einkaufskondition anlegen',
    editTitle: 'Einkaufskondition bearbeiten',
    description: 'Konditionen gelten für diesen Lieferanten und den gewählten Artikel.',
    product: 'Artikel',
    productHint: 'Nach Artikelnummer oder Bezeichnung suchen.',
    productPlaceholder: 'Artikel suchen …',
    noProducts: 'Keine Artikel gefunden.',
    supplierSku: 'Artikelnr. beim Lieferanten',
    purchasePrice: 'EK-Preis (netto)',
    packagingUnit: 'Verpackungseinheit',
    packagingFactor: 'Basiseinheiten je VPE',
    leadTimeDays: 'Lieferzeit (Tage)',
    minOrderQuantity: 'Mindestbestellmenge',
    isPreferredSupplier: 'Vorzugslieferant für diesen Artikel',
    preferred: 'Vorzug',
    notes: 'Notiz',
    empty: 'Noch keine Einkaufskonditionen hinterlegt.',
    saved: 'Einkaufskondition gespeichert.',
    saveError: 'Die Einkaufskondition konnte nicht gespeichert werden.',
    loadError: 'Die Einkaufskonditionen konnten nicht geladen werden.',
    edit: 'Einkaufskondition bearbeiten',
    delete: 'Einkaufskondition löschen',
    deleted: 'Einkaufskondition gelöscht.',
    deleteTitle: 'Einkaufskondition löschen',
    deleteDescription: 'Die Konditionen für "{{name}}" werden entfernt.',
    columns: {
      article: 'Artikel',
      supplierSku: 'Lieferanten-Nr.',
      purchasePrice: 'EK-Preis',
      packaging: 'VPE',
      leadTimeDays: 'Lieferzeit',
      minOrderQuantity: 'Mindestmenge',
      preferred: 'Vorzug',
    },
  },
  supplierOrders: {
    purchaseOrder: 'Bestellung',
    itemCount_one: '{{count}} Position',
    itemCount_other: '{{count}} Positionen',
    deliveryDate: 'Wareneingang {{date}}',
    empty: 'Noch keine Bestellungen bei diesem Lieferanten.',
    loadError: 'Die Bestellungen konnten nicht geladen werden.',
  },
  addresses: {
    title: 'Abweichende Adressen',
    add: 'Adresse',
    isDefault: 'Standard',
    empty: 'Keine abweichenden Adressen hinterlegt.',
    deleted: 'Adresse gelöscht.',
    delete: 'Adresse löschen',
    deleteTitle: 'Adresse löschen',
    deleteDescription: 'Die Adresse wird aus dem Partnerstamm entfernt.',
    loadError: 'Die Adressen konnten nicht geladen werden.',
    types: {
      BILLING: 'Rechnungsadresse',
      SHIPPING: 'Lieferadresse',
      OTHER: 'Sonstige',
    },
  },
  contacts: {
    title: 'Ansprechpartner',
    add: 'Ansprechpartner',
    isPrimary: 'Hauptkontakt',
    empty: 'Keine Ansprechpartner hinterlegt.',
    deleted: 'Ansprechpartner gelöscht.',
    delete: 'Ansprechpartner löschen',
    deleteTitle: 'Ansprechpartner löschen',
    deleteDescription: 'Der Ansprechpartner wird aus dem Partnerstamm entfernt.',
    loadError: 'Die Ansprechpartner konnten nicht geladen werden.',
  },
  customFields: {
    title: 'Dynamische Zusatzfelder',
    subtitle: 'Sichtbar sind nur Felder, die zu den Rollen dieses Partners passen.',
    empty: 'Für die Rollen dieses Partners sind keine Zusatzfelder definiert.',
    saved: 'Zusatzfelder gespeichert.',
  },
};
